"use client";

import { useEffect } from "react";

/**
 * body の pointer-events: none 残留に対するグローバルガード。
 *
 * Radix UI では DropdownMenu の項目クリックから AlertDialog / Dialog を
 * 開閉すると、モーダルレイヤーの参照カウントがずれて body の
 * pointer-events: none が残留し、リロードするまでページ全体が操作不能に
 * なることがある（一覧の「…」メニュー → 削除確認 → 削除実行 の流れで頻発）。
 *
 * 各 Dialog/AlertDialog のアンマウント時クリーンアップ
 * （useModalPointerEventsCleanup）だけでは、Radix が後から style を
 * 再設定するケースを拾えないため、body の style 変更自体を
 * MutationObserver で監視し、「開いているモーダルが無いのに
 * pointer-events: none」の状態をデバウンス後に解除する。
 *
 * 正当にモーダル・メニューが開いている間は解除しないので副作用はない。
 */
export function usePointerEventsGuard() {
  useEffect(() => {
    const hasOpenModalLayer = () =>
      document.querySelector(
        [
          '[data-state="open"][role="dialog"]',
          '[data-state="open"][role="alertdialog"]',
          '[data-state="open"][role="menu"]',
          '[data-state="open"][role="listbox"]',
          "[data-radix-popper-content-wrapper]",
        ].join(", ")
      );

    let timer: number | undefined;
    const check = () => {
      if (
        document.body.style.pointerEvents === "none" &&
        !hasOpenModalLayer()
      ) {
        document.body.style.pointerEvents = "";
      }
    };

    const observer = new MutationObserver(() => {
      // Radix の後処理（閉じアニメーション含む）より後に判定する
      window.clearTimeout(timer);
      timer = window.setTimeout(check, 500);
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => {
      observer.disconnect();
      window.clearTimeout(timer);
    };
  }, []);
}
